import { Component, Input, OnInit, Output, AfterContentInit, EventEmitter } from '@angular/core';
import { PropertyService } from '../shared/property.service';
import { EventService } from '../shared/event.service';

declare var ol: any;

@Component({
  selector: 'sold-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit, AfterContentInit {

  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  
  icon: any;
  map: any;


  constructor(public _propertyService: PropertyService, private _eventService: EventService) {

  }

  closeSidenav() {
    this._eventService.eventFromSender();
  }

  ngAfterContentInit() {
    
  }

  ngOnInit() {

    this.map = new ol.Map({
      target: 'map',
      layers: [
          new ol.layer.Tile({
              source: new ol.source.OSM({
                  attributions: [
                      new ol.Attribution({
                          html: 'Tiles courtesy of OpenStreetMap'
                      }),
                      ol.source.OSM.ATTRIBUTION
                  ],
                  url: "https://{a-c}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png"
              })
          })
      ],
      view: new ol.View({
          center: ol.proj.fromLonLat([this._propertyService.longitude, this._propertyService.latitude]),
          zoom: 14
      }),
      interactions: ol.interaction.defaults({
          doubleClickZoom: false,
          dragAndDrop: false,
          keyboardPan: false,
          keyboardZoom: false,
          mouseWheelZoom: false,
          pointer: false,
          select: false,
          dragPan: true
      })
  });

      switch (this._propertyService.brand) {
        case 'hrt':
        this.icon = 'assets/images/icons/haart/map-marker.png';
        break;
        case 'dar':
        this.icon = 'assets/images/icons/darlows/map-marker.png';
        break;
        case 'hay':
        this.icon = 'assets/images/icons/haybrook/map-marker.png';
        break;
        case 'fjl':
        this.icon = 'assets/images/icons/fjlord/map-marker.png';
        break;
        case 'brh':
        this.icon = 'assets/images/icons/bholt/map-marker.png';
    }

    var view = this.map.getView();

    //view.setZoom(15);

    var iconFeatures = [];

    var iconFeature = new ol.Feature({
        geometry: new ol.geom.Point(ol.proj.transform([this._propertyService.longitude, this._propertyService.latitude], 'EPSG:4326',
            'EPSG:3857')),
        name: 'Null Island',
        population: 4000,
        rainfall: 500
    });

    iconFeatures.push(iconFeature);

    var vectorSource = new ol.source.Vector({
        features: iconFeatures
    });


    var iconStyle = new ol.style.Style({
        image: new ol.style.Icon(({
            anchor: [10, 10],
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels',
            opacity: 0.75,
            src: this.icon
        }))
    });

    var vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        style: iconStyle
    });

    this.map.addLayer(vectorLayer);

    // view.setCenter(ol.proj.fromLonLat([this._propertyService.longitude, this._propertyService.latitude]));
    // view.setZoom(14);
  }



  setCenter() {
    var view = this.map.getView();

    var iconFeatures = [];

    var iconFeature = new ol.Feature({
        geometry: new ol.geom.Point(ol.proj.transform([this._propertyService.longitude, this._propertyService.latitude], 'EPSG:4326',
            'EPSG:3857')),
        name: 'Null Island',
        population: 4000,
        rainfall: 500
    });

    iconFeatures.push(iconFeature);

    var vectorSource = new ol.source.Vector({
        features: iconFeatures
    });


    var iconStyle = new ol.style.Style({
        image: new ol.style.Icon(({
            anchor: [10, 10],
            anchorXUnits: 'pixels',
            anchorYUnits: 'pixels',
            opacity: 0.75,
            src: this.icon
        }))
    });

    var vectorLayer = new ol.layer.Vector({
        source: vectorSource,
        style: iconStyle
    });

    this.map.addLayer(vectorLayer);

    view.setCenter(ol.proj.fromLonLat([this._propertyService.longitude, this._propertyService.latitude]));
    view.setZoom(14);
}





}



// WEBPACK FOOTER //
// D:/FLINK/FlinkViewingPageDec2020/NewLandingPage/src/app/map/map.component.ts